import fetch from '../utils/fetch'

import stringToPrice from '../utils/stringToPrice'

import { BASE_URL } from './constants'


export const createOrUpdatePolicy = (policy) => {
  // deep copy coverages
  const copyCoverages = policy.policy.coverages.map(coverage => ({...coverage, claims: [{...coverage.claims[0]}]}))
  const copyPolicy = {...policy.policy, coverages:copyCoverages}

  copyCoverages.forEach(coverage => {
    coverage.coverageAmount = stringToPrice(coverage.coverageAmount)
    coverage.claims[0].claimAmount = stringToPrice(coverage.claims[0].claimAmount)
  })

  return fetch(`${BASE_URL}/create-or-update-policy/`, {
    method: 'POST',
    body: JSON.stringify({policy: copyPolicy})
  })
}

export const addNote = (note) => {
  return fetch(`${BASE_URL}/add-note/`, {
    method: 'POST',
    body: JSON.stringify(note)
  })
}

export const getPoliciesByMerchantId = () => {
  return fetch(`${BASE_URL}/search-recent-policy-by-merchant-id/`)
}

export const getRecentPoliciesByClaimStatus = () => {
  return fetch(`${BASE_URL}/get-recent-policies-by-claim-status/?status=[%22requested%22,%22returned%22,%22approved%22]`)
}

export const getPolicyByPolicyId = (policyId) => {
  return fetch(`${BASE_URL}/get-policy-by-policy-id/${policyId}`)
}

export const getPolicyByTaobaoId = (taobaoId) => {
  return fetch(`${BASE_URL}/get-policy-by-taobao-order-id/${taobaoId}`)
}

export const searchZhonganPloicies = ({ startDate, endDate, searchType, query, partner, taobaoStatus, taobaoReturnWarehouseId, start, limit, rest }) => {
  if (taobaoStatus === 'CREATED_AND_RECEIVED') {
    taobaoStatus = 'created';
    rest = '&taobaoReturnQuantity=1'
  }
  return fetch(`${BASE_URL}/search-policy/?partner=${partner}&startDate=${startDate}&endDate=${endDate}&${searchType}=${query}&taobaoStatus=${taobaoStatus}&taobaoReturnWarehouseId=${taobaoReturnWarehouseId}&start=${start}&limit=${10000}${rest ? rest : ''}`)
}

export const searchSLabPloicies = ({ startDate, endDate, query, partner, slabCountry, slabOrderStatus, slabClaimStatus, start, limit }) => {
  return fetch(`${BASE_URL}/search-policy/?partner=${partner}&startDate=${startDate}&endDate=${endDate}&slabOrderId=${query}&slabCountry=${slabCountry}&slabOrderStatus=${slabOrderStatus}&slabClaimStatus=${slabClaimStatus}&start=${start}&limit=${limit}`)
}

export const searchPloicyByTrackingNumber = (trackingNumber) => {
  return fetch(`${BASE_URL}/search-policy/?partner=taobao&taobaoReturnTrackingNumber=${trackingNumber}&limit=${20}`)
}

export const searchReceivedCoverages = ({ startDate, endDate, query, resellStatus, start, limit }) => {
  return fetch(`${BASE_URL}/search-coverage/?startDate=${startDate}&endDate=${endDate}&coverageId=${query}${resellStatus.reduce((accumulator, currentValue) => (`${accumulator}&${`resellStatus=${currentValue}`}`), '')}`)
}

export const getPolicy = (policyId) => {
  return fetch(`${BASE_URL}/policy/${policyId}`)
}

export const updateClaimStatus = ({ partner, status, coverageId, policyId, extRef, claimId }) => {
  return fetch(`${BASE_URL}/update-claim-status/${claimId}`, {
    method: 'POST',
    body: JSON.stringify({partner, status, coverageId, policyId, extRef})
  })
}

export const getWarehouseRecords = (policyId) => {
  return fetch(`${BASE_URL}/policy/${policyId}/warehouse-records/`)
}

export const updateCoverage = (coverageId, policyId, coverageUpdates) => {
  return fetch(`${BASE_URL}/policy/${policyId}/coverage/${coverageId}`, {
    method: 'PUT',
    body: JSON.stringify(coverageUpdates)
  })
}

const formatArrayInUrl = (elms, name) => {
  return elms.map(elm => `${name}=${elm}`).join('&')
}

export const getUserNamesById = (ids) => {
  return fetch(`${BASE_URL}/get-username-from-ids/?${formatArrayInUrl(ids, 'ids')}`)
}

export const createInventoryItem = (inventoryItem) => {
  return fetch(`${BASE_URL}/stockin/`, {
    method: 'POST',
    body: JSON.stringify(inventoryItem)
  })
}

export const updateInventoryItemData = (entityId, inventoryItem) => {
  return fetch(`${BASE_URL}/stockin/${entityId}`, {
    method: 'PUT',
    body: JSON.stringify(inventoryItem)
  })
}



// WEBPACK FOOTER //
// ./src/services/policyServices.js